import { render, staticRenderFns } from "./RoomTypes.vue?vue&type=template&id=069b7bc6&scoped=true&"
import script from "./RoomTypes.vue?vue&type=script&lang=js&"
export * from "./RoomTypes.vue?vue&type=script&lang=js&"
import style0 from "./RoomTypes.vue?vue&type=style&index=0&id=069b7bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069b7bc6",
  null
  
)

export default component.exports